import React from "react";
import { useRouter } from "lib/hooks/useRouter";
import { SelectProduct } from "containers/SelectProduct/SelectProduct";
import { BulkSelectProducts } from "containers/BulkSelectProducts/BulkSelectProducts";
import { SkipBags } from "containers/SkipBags/SkipBags";
import { Skips } from "containers/Skips/Skips";
import { BinCollection } from "containers/BinCollection/BinCollection";

export const ServicePage = (): React.ReactElement => {
  const { getParams } = useRouter("ServicePage");
  const [
    categorySku,
    postcode,
    wasteType,
    products,
    type,
    isPaid,
    ref,
    bagContentsTypes,
    bagContentsNotes,
    distanceFromRoad,
    readyToCollect,
    previousSkip,
  ] = getParams([
    "categorySku",
    "postcode",
    "wasteType",
    "products",
    "type",
    "isPaid",
    "ref",
    "bagContentsTypes",
    "bagContentsNotes",
    "distanceFromRoad",
    "readyToCollect",
    "previousSkip",
  ]);

  if (["HOUSECLEARANCE"].includes(String(categorySku))) {
    return <BulkSelectProducts categorySku={String(categorySku)} />;
  }

  if (categorySku === "SKIPBAGS") {
    return (
      <SkipBags
        queryParams={{
          type,
          postcode,
          products,
          isPaid,
          ref,
          bagContentsTypes,
          bagContentsNotes,
          distanceFromRoad,
          readyToCollect,
        }}
      />
    );
  }

  if (categorySku === "BINCOL") {
    return <BinCollection postcode={postcode} />;
  }

  if (categorySku === "SKIPS") {
    return (
      <Skips
        queryParams={{
          type,
          postcode,
          products,
          ref,
          wasteType,
          previousSkip,
        }}
      />
    );
  }

  return (
    <SelectProduct
      categorySku={categorySku || ""}
      postcode={postcode}
      wasteType={wasteType}
    />
  );
};
